import { GameTicketProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameTicketProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TicketLandscapeProperties.ts
 */
export class TicketLandscapeProperties extends GameTicketProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.symbolPanelProperties.scale.set(0.774);
        this.symbolPanelProperties.position.set(641, 70);
        this.symbolPanelProperties.layout = new GridLayout(5, 5, 167, 166);
        this.reelAreaProperties.position.set(644, 72);
    }
    equals(other) {
        return false;
    }
}
